import styled from 'styled-components';

export const NavStyled = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
  }
`;
